import React from 'react';
import LegalPage from './LegalPage';

const Terminos = () => {
  const sections = [
    {
      heading: 'Aceptación de los términos',
      paragraphs: [
        'Al acceder y utilizar el sitio web de SEBINOR Computación (en adelante, "el sitio"), usted acepta cumplir y quedar vinculado por los presentes Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, le solicitamos que no utilice el sitio.',
        'SEBINOR Computación se reserva el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigencia desde su publicación en esta página.'
      ]
    },
    {
      heading: 'Servicios ofrecidos',
      paragraphs: [
        'SEBINOR Computación ofrece a través de este sitio información sobre venta de equipos informáticos, servicio técnico, armado de PC, impresión 3D, estudio de grabación, desarrollo de páginas web y productos de electrónica del hogar.'
      ],
      bullets: [
        'Venta de computadoras, notebooks, consolas y electrónica.',
        'Servicio técnico profesional con diagnóstico.',
        'Servicios de impresión 3D y diseño.',
        'Estudio de grabación, ensayos y streaming.',
        'Desarrollo, hosting y posicionamiento de sitios web.'
      ]
    },
    {
      heading: 'Cotizaciones y precios',
      paragraphs: [
        'Los precios publicados en el sitio son de referencia y pueden sufrir modificaciones sin previo aviso debido a variaciones del mercado, disponibilidad de stock o cotización de divisas.',
        'La confirmación definitiva del precio, condiciones de pago y plazos de entrega se realiza mediante contacto directo por WhatsApp, teléfono o en nuestro local comercial.'
      ]
    },
    {
      heading: 'Compras y pagos',
      paragraphs: [
        'El sitio no procesa pagos online de forma directa. Todas las operaciones de compra se coordinan por los canales de contacto (WhatsApp, teléfono o presencial). El cliente es responsable de verificar los datos del producto y las condiciones comerciales antes de concretar la compra.'
      ]
    },
    {
      heading: 'Garantías',
      paragraphs: [
        'Los productos nuevos cuentan con la garantía del fabricante. Los equipos reacondicionados y de outlet poseen la garantía indicada en la publicación, la cual cubre defectos de funcionamiento no derivados de mal uso, golpes, humedad o manipulación por terceros.',
        'Para hacer efectiva la garantía es necesario presentar el comprobante de compra. SEBINOR Computación evaluará el equipo y determinará la solución más adecuada (reparación, cambio o reintegro) según corresponda.'
      ]
    },
    {
      heading: 'Servicio técnico',
      paragraphs: [
        'El diagnóstico técnico puede tener un costo informado al momento de la consulta. Los trabajos sólo se inician con la aprobación expresa del presupuesto por parte del cliente.',
        'Los equipos no retirados dentro de los 60 días corridos desde la finalización del trabajo o notificación quedarán sujetos a lo dispuesto por la normativa vigente.'
      ]
    },
    {
      heading: 'Uso del sitio',
      paragraphs: [
        'El usuario se compromete a utilizar el sitio de buena fe, respetando la legislación vigente y los derechos de terceros. Está prohibido:'
      ],
      bullets: [
        'Realizar cualquier acción que pueda dañar, inutilizar o sobrecargar el sitio.',
        'Reproducir, copiar o redistribuir el contenido sin autorización.',
        'Suplantar la identidad de otra persona o entidad.',
        'Enviar información falsa, maliciosa o publicitaria no solicitada.'
      ]
    },
    {
      heading: 'Propiedad intelectual',
      paragraphs: [
        'Todos los contenidos del sitio (textos, logotipos, imágenes, diseño y código) son propiedad de SEBINOR Computación o de sus respectivos titulares y están protegidos por las leyes de propiedad intelectual vigentes en la República Argentina.'
      ]
    },
    {
      heading: 'Enlaces a sitios de terceros',
      paragraphs: [
        'El sitio puede contener enlaces a páginas externas (como nuestra tienda de electrónica del hogar, redes sociales o reseñas en Google). SEBINOR Computación no se responsabiliza por el contenido, políticas o prácticas de dichos sitios.'
      ]
    },
    {
      heading: 'Limitación de responsabilidad',
      paragraphs: [
        'SEBINOR Computación no será responsable por daños directos o indirectos derivados del uso o imposibilidad de uso del sitio, errores u omisiones en los contenidos, o interrupciones del servicio.'
      ]
    },
    {
      heading: 'Legislación aplicable',
      paragraphs: [
        'Los presentes Términos de Servicio se rigen por las leyes de la República Argentina. Ante cualquier controversia, las partes se someten a los tribunales ordinarios de la Provincia de Buenos Aires, con renuncia expresa a cualquier otro fuero.'
      ]
    },
    {
      heading: 'Contacto',
      paragraphs: [
        'Ante cualquier duda o consulta sobre estos Términos de Servicio podés comunicarte con nosotros a través de WhatsApp al +54 9 15 2610-6011, por correo a sebinorcomputacion@yahoo.com o acercarte a Av. Libertador 7615.'
      ]
    }
  ];

  return (
    <LegalPage
      title="Términos de servicio"
      subtitle="Condiciones generales que regulan el uso de nuestro sitio y los servicios ofrecidos por SEBINOR Computación."
      lastUpdated="Diciembre 2025"
      sections={sections}
    />
  );
};

export default Terminos;
